export const SEARCH_TYPE = 'search';
export const SOURCE_TYPE = 'source';
export const COMPANY_TYPE = 'company';
export const CATEGORY_TYPE = 'category';
export const PRACTICES_TYPE = 'practices';
export const INDUSTRIES_TYPE = 'industries';
export const TOPICS_TYPE = 'topics';
export const SEARCH_TYPE_ID_PRACTICE = 1;
export const SEARCH_TYPE_ID_INDUSTRY = 2;
export const SEARCH_TYPE_ID_TOPIC = 3;

export const searchTabs = [
    { type: 'alerts', name: 'Searches' },
    { type: 'alertGroups', name: 'Groups' },
];

export const sourceTabs = [
    { type: 'alerts', name: 'My Sources' },
    { type: 'alertGroups', name: 'Groups' },
    { type: 'labels', name: 'Labels' },
];

export const companyTabs = [{ type: 'alerts', name: 'Company' }];

export const categoryTabs = {
    [PRACTICES_TYPE]: [{ type: 'alerts', name: 'Practices', searchTypeId: SEARCH_TYPE_ID_PRACTICE }],
    [INDUSTRIES_TYPE]: [{ type: 'alerts', name: 'Industries', searchTypeId: SEARCH_TYPE_ID_INDUSTRY }],
    [TOPICS_TYPE]: [{ type: 'alerts', name: 'Topics', searchTypeId: SEARCH_TYPE_ID_TOPIC }],
};

export const headerByType = {
    [SEARCH_TYPE]: 'Searches',
    [SOURCE_TYPE]: 'Manage Sources',
    [COMPANY_TYPE]: 'Companies',
    [INDUSTRIES_TYPE]: 'Manage Industries',
    [PRACTICES_TYPE]: 'Manage Practices',
    [TOPICS_TYPE]: 'Manage Topics',
};
